import { MessageCircle } from "lucide-react";
import { SITE } from "../data/site";

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-float-button"
    href={SITE.whatsappLink}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Terra Bloom on WhatsApp"
    className="fixed bottom-6 right-6 z-50 group"
  >
    <span className="absolute inset-0 rounded-full bg-emerald-500 animate-pulse-ring" />
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-[0_10px_30px_rgba(16,185,129,0.4)] transition-transform duration-300 group-hover:scale-110">
      <MessageCircle className="h-6 w-6" fill="currentColor" strokeWidth={0} />
    </span>
  </a>
);
